<template>
	<div class="search">
		<div class="search__wrapper">
			<div class="search__input">
				<input type="text"
          class="form-input"
          v-model="searchValue"
          @change="searchSubmit">
			</div>
			<button class="button"
        @click="searchSubmit">{{$t('controls.searchHolder')}}</button>
		</div>
	</div>
</template>

<script>
export default {
    props: ['searchData'],
    data() {
        return {
            searchValue: '',
        }
    },
    methods: {
        searchSubmit() {
            this.$emit('searchData', this.searchValue)
        },
    },
}
</script>
<style lang="scss" scoped>
@import 'src/assets/sass/main';
.search {
	// max-width: 320px;
	border-radius: 8px;
	overflow: hidden;
	&__wrapper {
		display: flex;
		width: 100%;
	}
	&__input {
		position: relative;
		width: calc(100% - 10px);
		height: 50px;
		margin-right: 10px;
		background-color: #ffffff;
		display: flex;
		border-radius: 8px;
		justify-content: space-between;
		& .form-input {
			width: 100%;
			border: none;
			padding-left: 25px !important;
			box-sizing: border-box;
		}
		&::before {
			content: url('/images/icon/search.svg');
			position: relative;
			top: 0;
			left: 15px;
			display: flex;
			align-items: center;
		}
	}
	& .button {
		width: 100px;
		color: $secondColor;
	}
}
</style>
